import PanelNavigation from 'LayoutBuilderUI/components/panels/sidebar/PanelNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
const SidebarPanelContent = () => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "sidebar-content",
    children: /*#__PURE__*/_jsx(PanelNavigation, {})
  });
};
export default SidebarPanelContent;